import { useTranslation } from "react-i18next"

import { useBikeStore } from "hooks"

export const BikeDescription = ({ 
    className = "", 
    toggleReadOnly = null 
}) => {
    const {
        currentBike: bike
    } = useBikeStore()
    const { t } = useTranslation()

    return (
        <div className={`w-full ${className}`}>
            <div className="c-card p-5 md:p-12 mb-5">
                <h2 className="c-h2 font-semibold mb-7 uppercase">
                    {t("description_title", { ns: "bike" })}
                </h2>
                <p className="mb-2">
                    <span className="text-black font-bold">{t("brand", { ns: "bike" })} : </span>
                    <span className="text-primary ml-2">{bike?.bikeBrand}</span>
                </p>
                <p className="mb-2">
                    <span className="text-black font-bold">{t("model", { ns: "bike" })} : </span>
                    <span className="text-primary ml-2">{bike?.bikeModel}</span>
                </p>
                <p className="mb-2">
                    <span className="text-black font-bold">{t("type", { ns: "bike" })} : </span>
                    <span className="text-primary ml-2">{t(bike?.bikeType)}</span>
                </p>
                <p className="mb-2">
                    <span className="text-black font-bold">{t("color", { ns: "bike" })} : </span>
                    <span className="text-primary ml-2">{bike?.bikeColor}</span>
                </p>
                <p className="mb-7">
                    <span className="text-black font-bold">{t("label_vae_short", { ns: "bike" })} : </span>
                    <span className="text-primary ml-2">{bike?.isVAE === "true" ? t("label_vae_true", { ns: "bike" }) : t("label_vae_false", { ns: "bike" })}</span>
                </p>
                <p className="mb-2">
                    <span className="text-black font-bold">{t("serial", { ns: "bike" })} : </span>
                    <span className="text-primary ml-2">{bike?.bikeSerial}</span>
                </p>

                {bike?.isVAE === "true" &&
                    <>
                        <p className="mb-2">
                            <span className="text-black font-bold">{t("serial_engine", { ns: "bike" })} : </span>
                            <span className="text-primary ml-2">{bike?.bikeEngineSerial}</span>
                        </p>
                        <p className="mb-2">
                            <span className="text-black font-bold">{t("serial_battery", { ns: "bike" })} : </span>
                            <span className="text-primary ml-2">{bike?.bikeBatterySerial}</span>
                        </p>
                    </>
                }
                {
                    toggleReadOnly &&
                    <button
                        className="c-btn c-btn--primary px-5 ml-auto"
                        onClick={toggleReadOnly}
                    >
                        {t("global.update")}
                    </button>
                }
            </div>
        </div>
    )
}